"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dmetVariable = exports.dmetTable = exports.dmetList = exports.dmet = void 0;
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _common = _interopRequireWildcard(require("../util/common"));
var _excluded = ["list", "data", "value", "_id", "id", "fields"],
  _excluded2 = ["list", "array", "value", "_id", "id"],
  _excluded3 = ["array", "_id", "id"],
  _excluded4 = ["value", "_id", "id"],
  _excluded5 = ["value", "_id", "id"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _classPrivateSetter(s, r, a, t) { return r(_assertClassBrand(s, a), t), t; }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _id2 = /*#__PURE__*/new WeakMap();
var _key2 = /*#__PURE__*/new WeakMap();
var _object = /*#__PURE__*/new WeakMap();
var _array = /*#__PURE__*/new WeakMap();
var _origin = /*#__PURE__*/new WeakMap();
var _fields = /*#__PURE__*/new WeakMap();
var _originFields = /*#__PURE__*/new WeakMap();
var _info = /*#__PURE__*/new WeakMap();
var _maxRow = /*#__PURE__*/new WeakMap();
var _maxCol = /*#__PURE__*/new WeakMap();
var _variableType = /*#__PURE__*/new WeakMap();
var _keyDelimter = /*#__PURE__*/new WeakMap();
var _dmetTable_brand = /*#__PURE__*/new WeakSet();
var _skipOperation = /*#__PURE__*/new WeakMap();
var dmetTable = exports.dmetTable = /*#__PURE__*/function () {
  function dmetTable() {
    var _array2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var id = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2["default"])(this, dmetTable);
    _classPrivateMethodInitSpec(this, _dmetTable_brand);
    (0, _defineProperty2["default"])(this, "_id", undefined);
    (0, _defineProperty2["default"])(this, "__isUpdate", false);
    _classPrivateFieldInitSpec(this, _id2, '');
    _classPrivateFieldInitSpec(this, _key2, _common["default"].generateId());
    _classPrivateFieldInitSpec(this, _object, {});
    _classPrivateFieldInitSpec(this, _array, []);
    _classPrivateFieldInitSpec(this, _origin, []);
    _classPrivateFieldInitSpec(this, _fields, []);
    _classPrivateFieldInitSpec(this, _originFields, []);
    _classPrivateFieldInitSpec(this, _info, {});
    _classPrivateFieldInitSpec(this, _maxRow, 3000);
    _classPrivateFieldInitSpec(this, _maxCol, 100);
    _classPrivateFieldInitSpec(this, _variableType, 'table');
    _classPrivateFieldInitSpec(this, _keyDelimter, '_');
    _classPrivateFieldInitSpec(this, _skipOperation, ['appendRow', 'appendCol', 'insertRow', 'insertCol']);
    _classPrivateFieldSet(_id2, this, id);
    this.from(_array2);
  }
  return (0, _createClass2["default"])(dmetTable, [{
    key: "fields",
    get: function get() {
      return _classPrivateFieldGet(_fields, this);
    }
  }, {
    key: "originFields",
    get: function get() {
      return _classPrivateFieldGet(_originFields, this);
    }
  }, {
    key: "value",
    get: function get() {
      return _classPrivateFieldGet(_object, this);
    }
  }, {
    key: "array",
    get: function get() {
      return _classPrivateFieldGet(_array, this);
    }
  }, {
    key: "isDmet",
    get: function get() {
      return true;
    }
  }, {
    key: "variableType",
    get: function get() {
      return _classPrivateFieldGet(_variableType, this);
    }
  }, {
    key: "origin",
    get: function get() {
      return _classPrivateFieldGet(_origin, this);
    }
  }, {
    key: "setLabel",
    value: function setLabel(index, name) {
      _classPrivateFieldGet(_fields, this)[index] = name;
    }
  }, {
    key: "from",
    value: function from(data) {
      var _this = this;
      var _data$list = data.list,
        list = _data$list === void 0 ? [] : _data$list,
        _data$data = data.data,
        array = _data$data === void 0 ? [] : _data$data,
        value = data.value,
        _id = data._id,
        _data$id = data.id,
        id = _data$id === void 0 ? _classPrivateFieldGet(_id2, this) : _data$id,
        _data$fields = data.fields,
        fields = _data$fields === void 0 ? [] : _data$fields,
        info = (0, _objectWithoutProperties2["default"])(data, _excluded);
      _classPrivateFieldSet(_object, this, {});
      _classPrivateFieldSet(_array, this, []);
      _classPrivateFieldSet(_origin, this, []);
      if (Array.isArray(array)) {
        array.forEach(function () {
          var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          if (Array.isArray(row)) {
            var key = _common["default"].generateId();
            var _value = row.map(_common.toNumber);
            _assertClassBrand(_dmetTable_brand, _this, _fillArray).call(_this, _value, fields.length);
            _classPrivateFieldGet(_array, _this).push({
              key: key,
              value: _value
            });
            _classPrivateFieldGet(_object, _this)[key] = _value;
            _classPrivateFieldGet(_origin, _this).push((0, _cloneDeep2["default"])(row));
          } else if ((0, _typeof2["default"])(row) === 'object' && row.key) {
            var newRow = {
              key: row.key,
              value: row.value.map(_common.toNumber)
            };
            _classPrivateFieldGet(_array, _this).push(newRow);
            _classPrivateFieldGet(_object, _this)[row.key] = newRow.value;
            _classPrivateFieldGet(_origin, _this).push((0, _cloneDeep2["default"])(row.value));
          }
        });
      }
      this._id = _id;
      _classPrivateFieldSet(_id2, this, id);
      _classPrivateFieldSet(_fields, this, fields);
      _classPrivateFieldSet(_originFields, this, (0, _toConsumableArray2["default"])(fields));
      _classPrivateFieldSet(_info, this, info);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        _id: this._id || undefined,
        id: _classPrivateFieldGet(_id2, this),
        key: _classPrivateFieldGet(_key2, this),
        data: _classPrivateFieldGet(_array, this),
        origin: _classPrivateFieldGet(_origin, this),
        fields: _classPrivateFieldGet(_fields, this),
        isDmet: true,
        variableType: this.variableType
      };
    }
  }, {
    key: "getRow",
    value: function getRow(key) {
      if (Array.isArray(key)) {
        var _key3 = (0, _slicedToArray2["default"])(key, 2),
          row = _key3[0],
          _key3$ = _key3[1],
          col = _key3$ === void 0 ? 0 : _key3$;
        var result = _classPrivateFieldGet(_array, this)[row - 1] || {};
        return _objectSpread(_objectSpread({}, result), {}, {
          x: row - 1,
          y: col - 1
        });
      } else if (typeof key === 'number') {
        var _result = _classPrivateFieldGet(_array, this)[key - 1] || {};
        return _objectSpread(_objectSpread({}, _result), {}, {
          x: key - 1
        });
      } else if (typeof key === 'string') {
        var _key$split = key.split(_classPrivateFieldGet(_keyDelimter, this)),
          _key$split2 = (0, _slicedToArray2["default"])(_key$split, 2),
          rowKey = _key$split2[0],
          _key$split2$ = _key$split2[1],
          _col = _key$split2$ === void 0 ? 0 : _key$split2$;
        return {
          key: rowKey,
          value: _classPrivateFieldGet(_object, this)[rowKey],
          x: this.getIndex(rowKey),
          y: _col - 1
        };
      }
      throw {
        message: "not found tableData ".concat(key, " id: ").concat(_classPrivateFieldGet(_id2, this))
      };
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      if (typeof key === 'number') {
        return _classPrivateFieldGet(_array, this)[key - 1].value;
      } else if (Array.isArray(key)) {
        var _key4 = (0, _toArray2["default"])(key),
          rowKey = _key4[0],
          keys = _arrayLikeToArray(_key4).slice(1);
        var _ref = _classPrivateFieldGet(_array, this)[rowKey - 1] || {},
          row = _ref.value;
        if (rowKey === 0) {
          row = _classPrivateFieldGet(_fields, this);
        }
        if (keys.length && row) {
          return (0, _get2["default"])(row, "[".concat(keys.map(function (x) {
            return x - 1;
          }).join(']['), "]"));
        } else {
          return row;
        }
      } else if (typeof key === 'string') {
        var _key$split3 = key.split(_classPrivateFieldGet(_keyDelimter, this)),
          _key$split4 = (0, _toArray2["default"])(_key$split3),
          _rowKey = _key$split4[0],
          _keys = _arrayLikeToArray(_key$split4).slice(1);
        if (_keys.length) {
          return (0, _get2["default"])(_classPrivateFieldGet(_object, this)[_rowKey], "[".concat(_keys.map(function (x) {
            return x - 1;
          }).join(']['), "]"));
        }
        return _classPrivateFieldGet(_object, this)[_rowKey];
      }
      throw {
        message: "not found tableData ".concat(key, " id: ").concat(_classPrivateFieldGet(_id2, this))
      };
    }
  }, {
    key: "getIndex",
    value: function getIndex(key) {
      if (Array.isArray(key)) {
        return key;
      } else if (typeof key === 'string') {
        var _key$split5 = key.split(_classPrivateFieldGet(_keyDelimter, this)),
          _key$split6 = (0, _toArray2["default"])(_key$split5),
          rowKey = _key$split6[0],
          keys = _arrayLikeToArray(_key$split6).slice(1);
        var rowIndex = _classPrivateFieldGet(_array, this).findIndex(function (x) {
          return x.key === rowKey;
        });
        if (rowIndex >= 0) {
          return [rowIndex].concat((0, _toConsumableArray2["default"])(keys));
        }
      }
      return [];
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref2.type,
        key = _ref2.key,
        index = _ref2.index,
        data = _ref2.data,
        newKey = _ref2.newKey;
      if (_classPrivateFieldGet(_skipOperation, this).indexOf(type) === -1 && typeof index === 'number') {
        var _data = this.getRow(index);
        key = _data.key;
      }
      var attach = {};
      switch (type) {
        case 'appendRow':
        case 'appendCol':
        case 'insertRow':
        case 'insertCol':
          attach = {
            index: index,
            data: data
          };
          break;
        case 'deleteCol':
        case 'deleteRow':
          attach = {
            index: index
          };
          break;
        case 'replace':
          attach = {
            data: data,
            index: index,
            newKey: newKey
          };
          break;
      }
      return _objectSpread({
        _id: this._id || undefined,
        id: _classPrivateFieldGet(_id2, this),
        variableType: this.variableType,
        key: key,
        type: type
      }, attach);
    }
  }, {
    key: "exec",
    value: function exec(operation) {
      var type = operation.type;
      this.__isUpdate = true;
      switch (type) {
        case 'appendCol':
          return _assertClassBrand(_dmetTable_brand, this, _appendCol).call(this, operation);
        case 'appendRow':
          return _assertClassBrand(_dmetTable_brand, this, _appendRow).call(this, operation);
        case 'insertRow':
          return _assertClassBrand(_dmetTable_brand, this, _insertRow).call(this, operation);
        case 'insertCol':
          return _assertClassBrand(_dmetTable_brand, this, _insertCol).call(this, operation);
        case 'deleteCol':
          return _assertClassBrand(_dmetTable_brand, this, _deleteCol).call(this, operation);
        case 'deleteRow':
          return _assertClassBrand(_dmetTable_brand, this, _deleteRow).call(this, operation);
        case 'replace':
          return _assertClassBrand(_dmetTable_brand, this, _replace).call(this, operation);
      }
    }
  }]);
}();
function _fillArray(array, length) {
  var start = array.length;
  array.length = length;
  array.fill(0, start, length);
}
function _getDefaultData() {
  var isRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  if (isRow) {
    return new Array(this.fields.length).fill(0);
  }
  return new Array(_classPrivateFieldGet(_array, this).length).fill(0);
}
function _getNewColName() {
  return Entry.getOrderedName(Lang.DataAnalytics.new_attribute, this.fields.map(function (name) {
    return {
      name: name
    };
  }), 'name');
}
function _appendCol() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    index = _ref6.index,
    _ref6$data = _ref6.data,
    data = _ref6$data === void 0 ? _assertClassBrand(_dmetTable_brand, this, _getDefaultData).call(this, false) : _ref6$data;
  this.fields.push(_assertClassBrand(_dmetTable_brand, this, _getNewColName).call(this));
  _classPrivateFieldGet(_array, this).forEach(function (_ref7, idx) {
    var value = _ref7.value;
    value.push(0);
  });
  return this.getOperation({
    type: 'appendCol',
    index: index,
    data: data
  });
}
function _insertCol() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    index = _ref8.index,
    _ref8$data = _ref8.data,
    data = _ref8$data === void 0 ? _assertClassBrand(_dmetTable_brand, this, _getDefaultData).call(this, false) : _ref8$data;
  if (index < 1 || index > this.fields.length + 1) {
    throw {
      message: "error: insertCol ".concat(index)
    };
  }
  this.fields.splice(index - 1, 0, _assertClassBrand(_dmetTable_brand, this, _getNewColName).call(this));
  _classPrivateFieldGet(_array, this).forEach(function (_ref9, idx) {
    var value = _ref9.value;
    value.splice(index - 1, 0, 0);
  });
  return this.getOperation({
    type: 'insertCol',
    index: index,
    data: data
  });
}
function _deleteCol(_ref0) {
  var index = _ref0.index;
  if (!index) {
    throw {
      message: "error: deleteCol : ".concat(index)
    };
  }
  this.fields.splice(index - 1, 1);
  _classPrivateFieldGet(_array, this).forEach(function (_ref1, idx) {
    var value = _ref1.value;
    value.splice(index - 1, 1);
  });
  return this.getOperation({
    type: 'deleteCol',
    index: index
  });
}
function _appendRow() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$key = _ref10.key,
    key = _ref10$key === void 0 ? _common["default"].generateId() : _ref10$key,
    _ref10$data = _ref10.data,
    data = _ref10$data === void 0 ? _assertClassBrand(_dmetTable_brand, this, _getDefaultData).call(this) : _ref10$data;
  var index = _classPrivateFieldGet(_array, this).length + 1;
  if (Array.isArray(data)) {
    _classPrivateFieldGet(_object, this)[key] = data;
    _classPrivateFieldGet(_array, this).splice(index, 0, {
      key: key,
      value: data
    });
  } else {
    console.warn('appendRow : ', key, data);
  }
  return this.getOperation({
    type: 'appendRow',
    key: key,
    index: index,
    data: data
  });
}
function _insertRow() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref11$key = _ref11.key,
    key = _ref11$key === void 0 ? _common["default"].generateId() : _ref11$key,
    index = _ref11.index,
    _ref11$data = _ref11.data,
    data = _ref11$data === void 0 ? _assertClassBrand(_dmetTable_brand, this, _getDefaultData).call(this) : _ref11$data;
  var value = (0, _common.toNumber)(data);
  if (Array.isArray(data) || index > _classPrivateFieldGet(_array, this).length + 1 || index < 0) {
    if (index === 0) {
      var fields = (0, _toConsumableArray2["default"])(data);
      data = (0, _toConsumableArray2["default"])(_classPrivateFieldGet(_fields, this));
      _classPrivateFieldSet(_fields, this, fields);
      index = 1;
    }
    _classPrivateFieldGet(_object, this)[key] = Array.isArray(data) ? data : [value];
    _classPrivateFieldGet(_array, this).splice(index - 1, 0, {
      key: key,
      value: _classPrivateFieldGet(_object, this)[key]
    });
  } else {
    console.warn('insert row : ', key, data, index);
  }
  return this.getOperation({
    type: 'insertRow',
    key: key,
    index: index,
    data: value
  });
}
function _deleteRow(_ref12) {
  var key = _ref12.key,
    index = _ref12.index;
  if (index === 0) {
    index = 1;
    var _this$getRow = this.getRow(index),
      _row = _this$getRow.value;
    _classPrivateFieldSet(_fields, this, (0, _toConsumableArray2["default"])(_row));
  }
  if (!key) {
    key = index;
  }
  var _this$getRow2 = this.getRow(key),
    row = _this$getRow2.value,
    objKey = _this$getRow2.key,
    x = _this$getRow2.x,
    y = _this$getRow2.y;
  if (!row || y > -1 && !row[y]) {
    throw {
      message: 'not found data'
    };
  }
  if (y > -1) {
    delete row[y];
  } else {
    delete _classPrivateFieldGet(_object, this)[objKey];
    _classPrivateFieldGet(_array, this).splice(x, 1);
  }
  return this.getOperation({
    type: 'deleteRow',
    key: key
  });
}
function _replace(_ref13) {
  var key = _ref13.key,
    index = _ref13.index,
    data = _ref13.data,
    _ref13$newKey = _ref13.newKey,
    newKey = _ref13$newKey === void 0 ? _common["default"].generateId() : _ref13$newKey;
  var value = (0, _common.toNumber)(data);
  if (!key) {
    key = index;
  }
  var _this$getRow3 = this.getRow(key),
    row = _this$getRow3.value,
    objKey = _this$getRow3.key,
    x = _this$getRow3.x,
    y = _this$getRow3.y;
  if (x === -1) {
    _classPrivateFieldGet(_fields, this)[y] = value;
  } else {
    if (!row) {
      throw {
        message: "not found row ".concat(y)
      };
    }
    row[y] = value;
  }
  return this.getOperation({
    type: 'replace',
    key: key,
    index: index,
    data: value,
    newKey: newKey
  });
}
var _id3 = /*#__PURE__*/new WeakMap();
var _key5 = /*#__PURE__*/new WeakMap();
var _object2 = /*#__PURE__*/new WeakMap();
var _array3 = /*#__PURE__*/new WeakMap();
var _info2 = /*#__PURE__*/new WeakMap();
var _variableType2 = /*#__PURE__*/new WeakMap();
var _dmetList_brand = /*#__PURE__*/new WeakSet();
var _skipOperation2 = /*#__PURE__*/new WeakMap();
var dmetList = exports.dmetList = /*#__PURE__*/function () {
  function dmetList() {
    var _array4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var id = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2["default"])(this, dmetList);
    _classPrivateMethodInitSpec(this, _dmetList_brand);
    (0, _defineProperty2["default"])(this, "_id", undefined);
    (0, _defineProperty2["default"])(this, "__isUpdate", false);
    _classPrivateFieldInitSpec(this, _id3, '');
    _classPrivateFieldInitSpec(this, _key5, _common["default"].generateId());
    _classPrivateFieldInitSpec(this, _object2, {});
    _classPrivateFieldInitSpec(this, _array3, []);
    _classPrivateFieldInitSpec(this, _info2, {});
    _classPrivateFieldInitSpec(this, _variableType2, 'list');
    _classPrivateFieldInitSpec(this, _skipOperation2, ['append', 'insert']);
    _classPrivateFieldSet(_id3, this, id);
    this.from(_array4);
  }
  return (0, _createClass2["default"])(dmetList, [{
    key: "value",
    get: function get() {
      return _classPrivateFieldGet(_array3, this);
    }
  }, {
    key: "array",
    get: function get() {
      return _classPrivateFieldGet(_array3, this);
    }
  }, {
    key: "isDmet",
    get: function get() {
      return true;
    }
  }, {
    key: "id",
    get: function get() {
      return _classPrivateFieldGet(_id3, this);
    }
  }, {
    key: "key",
    get: function get() {
      return _classPrivateFieldGet(_key5, this);
    }
  }, {
    key: "variableType",
    get: function get() {
      return _classPrivateFieldGet(_variableType2, this);
    }
  }, {
    key: "from",
    value: function from(data) {
      var _this3 = this;
      if (Array.isArray(data)) {
        _classPrivateSetter(_dmetList_brand, _set_data, this, data);
      } else if (data.isDmet || (0, _isPlainObject["default"])(data)) {
        var _data$list2 = data.list,
          list = _data$list2 === void 0 ? [] : _data$list2,
          _data$array = data.array,
          array = _data$array === void 0 ? [] : _data$array,
          value = data.value,
          _id = data._id,
          _data$id2 = data.id,
          id = _data$id2 === void 0 ? _classPrivateFieldGet(_id3, this) : _data$id2,
          info = (0, _objectWithoutProperties2["default"])(data, _excluded2);
        if (data.array && Array.isArray(array)) {
          _classPrivateFieldSet(_array3, this, array);
          _classPrivateFieldGet(_array3, this).map(function (value) {
            var key = value.key,
              _key = value._key;
            _classPrivateFieldGet(_object2, _this3)[key || _key] = value;
          });
        } else if (Array.isArray(list) && (0, _isPlainObject["default"])(value)) {
          _classPrivateFieldSet(_array3, this, list.map(function (key) {
            var data = {
              key: key,
              data: value[key]
            };
            _classPrivateFieldGet(_object2, _this3)[key] = data;
            return data;
          }));
        } else {
          _classPrivateFieldSet(_array3, this, []);
          _classPrivateFieldSet(_object2, this, {});
        }
        this._id = _id;
        _classPrivateFieldSet(_id3, this, id);
        _classPrivateFieldSet(_info2, this, info);
      } else if ('toJSON' in data) {
        var plainObject = data.toJSON();
        var _plainObject$array = plainObject.array,
          _array5 = _plainObject$array === void 0 ? [] : _plainObject$array,
          _id4 = plainObject._id,
          _plainObject$id = plainObject.id,
          _id5 = _plainObject$id === void 0 ? _classPrivateFieldGet(_id3, this) : _plainObject$id,
          _info3 = (0, _objectWithoutProperties2["default"])(plainObject, _excluded3);
        _classPrivateFieldSet(_array3, this, _array5);
        this._id = _id4;
        _classPrivateFieldSet(_id3, this, _id5);
        _classPrivateFieldSet(_info2, this, _info3);
        _classPrivateFieldGet(_array3, this).map(function (value) {
          var key = value.key,
            _key = value._key;
          _classPrivateFieldGet(_object2, _this3)[key || _key] = value;
        });
      } else {
        throw 'data is wrong.';
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      if (typeof key === 'number') {
        return _classPrivateFieldGet(_array3, this)[key];
      } else if (typeof key === 'string') {
        return _classPrivateFieldGet(_object2, this)[key];
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex(key) {
      if (typeof key === 'number') {
        return key;
      } else if (typeof key === 'string') {
        var oldData = _classPrivateFieldGet(_object2, this)[key];
        return _classPrivateFieldGet(_array3, this).indexOf(oldData);
      } else {
        return 0;
      }
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref3.type,
        key = _ref3.key,
        index = _ref3.index,
        data = _ref3.data,
        newKey = _ref3.newKey;
      if (_classPrivateFieldGet(_skipOperation2, this).indexOf(type) === -1 && typeof index === 'number') {
        var _data2 = this.get(index);
        key = _data2.key;
      }
      var attach = {};
      switch (type) {
        case 'append':
          attach = {
            data: data
          };
          break;
        case 'insert':
          attach = {
            index: index,
            data: data
          };
          break;
        case 'delete':
          attach = {
            index: index
          };
          break;
        case 'replace':
          attach = {
            data: data,
            newKey: newKey
          };
          break;
      }
      return _objectSpread({
        _id: this._id || undefined,
        id: _classPrivateFieldGet(_id3, this),
        variableType: this.variableType,
        key: key,
        type: type
      }, attach);
    }
  }, {
    key: "exec",
    value: function exec(operation) {
      var type = operation.type;
      this.__isUpdate = true;
      switch (type) {
        case 'append':
          return _assertClassBrand(_dmetList_brand, this, _append).call(this, operation);
        case 'insert':
          return _assertClassBrand(_dmetList_brand, this, _insert).call(this, operation);
        case 'delete':
          return _assertClassBrand(_dmetList_brand, this, _delete).call(this, operation);
        case 'replace':
          return _assertClassBrand(_dmetList_brand, this, _replace2).call(this, operation);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        _id: this._id || undefined,
        id: _classPrivateFieldGet(_id3, this),
        key: _classPrivateFieldGet(_key5, this),
        array: _classPrivateFieldGet(_array3, this),
        isDmet: true,
        variableType: this.variableType
      };
    }
  }]);
}();
function _set_data(_this2, array) {
  _classPrivateFieldSet(_array3, _this2, array.map(function (data) {
    var key = _common["default"].generateId();
    var item = {
      key: key,
      data: data
    };
    _classPrivateFieldGet(_object2, _this2)[key] = item;
    return item;
  }));
}
function _append() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    key = _ref14.key,
    data = _ref14.data;
  if (!key) {
    key = _common["default"].generateId();
  }
  var newData = {
    key: key,
    data: data
  };
  _classPrivateFieldGet(_object2, this)[key] = newData;
  _classPrivateFieldGet(_array3, this).push(newData);
  return this.getOperation({
    type: 'append',
    key: key,
    index: -1,
    data: data
  });
}
function _insert() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    key = _ref15.key,
    index = _ref15.index,
    data = _ref15.data;
  if (!key) {
    key = _common["default"].generateId();
  }
  var newData = {
    key: key,
    data: data
  };
  _classPrivateFieldGet(_object2, this)[key] = newData;
  _classPrivateFieldGet(_array3, this).splice(index, 0, newData);
  return this.getOperation({
    type: 'insert',
    key: key,
    index: index,
    data: data
  });
}
function _delete(_ref16) {
  var key = _ref16.key,
    index = _ref16.index;
  try {
    if (!key) {
      key = index;
    }
    var oldData = this.get(key);
    if (!oldData) {
      throw {
        message: 'not found data'
      };
    }
    var oldIndex = this.getIndex(key);
    delete _classPrivateFieldGet(_object2, this)[oldData.key];
    _classPrivateFieldGet(_array3, this).splice(oldIndex, 1);
    return this.getOperation({
      type: 'delete',
      key: key
    });
  } catch (e) {}
}
function _replace2(_ref17) {
  var key = _ref17.key,
    data = _ref17.data,
    _ref17$newKey = _ref17.newKey,
    newKey = _ref17$newKey === void 0 ? _common["default"].generateId() : _ref17$newKey;
  try {
    var item = this.get(key);
    if (!item) {
      throw {
        message: 'not found data'
      };
    }
    delete _classPrivateFieldGet(_object2, this)[item.key];
    item.key = newKey;
    item.data = data;
    _classPrivateFieldGet(_object2, this)[newKey] = item;
    return this.getOperation({
      type: 'replace',
      key: key,
      data: data,
      newKey: newKey
    });
  } catch (e) {}
}
var _id6 = /*#__PURE__*/new WeakMap();
var _key6 = /*#__PURE__*/new WeakMap();
var _info4 = /*#__PURE__*/new WeakMap();
var _value2 = /*#__PURE__*/new WeakMap();
var _variableType3 = /*#__PURE__*/new WeakMap();
var _dmetVariable_brand = /*#__PURE__*/new WeakSet();
var dmetVariable = exports.dmetVariable = /*#__PURE__*/function () {
  function dmetVariable() {
    var variable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var id = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2["default"])(this, dmetVariable);
    _classPrivateMethodInitSpec(this, _dmetVariable_brand);
    (0, _defineProperty2["default"])(this, "_id", undefined);
    _classPrivateFieldInitSpec(this, _id6, '');
    _classPrivateFieldInitSpec(this, _key6, _common["default"].generateId());
    _classPrivateFieldInitSpec(this, _info4, {});
    _classPrivateFieldInitSpec(this, _value2, '');
    _classPrivateFieldInitSpec(this, _variableType3, 'variable');
    _classPrivateFieldSet(_id6, this, id);
    this.from(variable);
  }
  return (0, _createClass2["default"])(dmetVariable, [{
    key: "value",
    get: function get() {
      return _classPrivateFieldGet(_value2, this);
    }
  }, {
    key: "id",
    get: function get() {
      return _classPrivateFieldGet(_id6, this);
    }
  }, {
    key: "key",
    get: function get() {
      return _classPrivateFieldGet(_key6, this);
    }
  }, {
    key: "variableType",
    get: function get() {
      return _classPrivateFieldGet(_variableType3, this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread(_objectSpread({}, _classPrivateFieldGet(_info4, this)), {}, {
        _id: this._id || undefined,
        id: _classPrivateFieldGet(_id6, this),
        key: _classPrivateFieldGet(_key6, this),
        value: this.value,
        isDmet: true,
        variableType: this.variableType
      });
    }
  }, {
    key: "from",
    value: function from(data) {
      if (typeof data === 'string') {
        _classPrivateFieldSet(_value2, this, data);
      } else if (data.isDmet || (0, _isPlainObject["default"])(data)) {
        var _data$value = data.value,
          value = _data$value === void 0 ? '' : _data$value,
          _id = data._id,
          _data$id3 = data.id,
          id = _data$id3 === void 0 ? _classPrivateFieldGet(_id6, this) : _data$id3,
          info = (0, _objectWithoutProperties2["default"])(data, _excluded4);
        _classPrivateFieldSet(_value2, this, value);
        this._id = _id;
        _classPrivateFieldSet(_id6, this, id);
        _classPrivateFieldSet(_info4, this, info);
      } else if ('toJSON' in data) {
        var plainObject = data.toJSON();
        var _plainObject$value = plainObject.value,
          _value3 = _plainObject$value === void 0 ? '' : _plainObject$value,
          _id7 = plainObject._id,
          _plainObject$id2 = plainObject.id,
          _id8 = _plainObject$id2 === void 0 ? _classPrivateFieldGet(_id6, this) : _plainObject$id2,
          _info5 = (0, _objectWithoutProperties2["default"])(plainObject, _excluded5);
        _classPrivateFieldSet(_value2, this, _value3);
        this._id = _id7;
        _classPrivateFieldSet(_id6, this, _id8);
        _classPrivateFieldSet(_info4, this, _info5);
      } else {
        throw 'data is wrong.';
      }
    }
  }, {
    key: "get",
    value: function get() {
      return _classPrivateFieldGet(_value2, this);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref4.type,
        value = _ref4.value;
      switch (type) {
        case 'set':
          return {
            _id: this._id,
            id: _classPrivateFieldGet(_id6, this),
            variableType: this.variableType,
            type: type,
            value: value
          };
      }
    }
  }, {
    key: "exec",
    value: function exec(operation) {
      var type = operation.type;
      switch (type) {
        case 'set':
          return _assertClassBrand(_dmetVariable_brand, this, _set).call(this, operation);
      }
    }
  }]);
}();
function _set(operation) {
  var value = operation.value;
  _classPrivateFieldSet(_value2, this, value);
  return operation;
}
var dmetSlideVariable = /*#__PURE__*/function (_dmetVariable2) {
  function dmetSlideVariable(variable, id) {
    (0, _classCallCheck2["default"])(this, dmetSlideVariable);
    variable.variableType = 'slide';
    return _callSuper(this, dmetSlideVariable, [variable, id]);
  }
  (0, _inherits2["default"])(dmetSlideVariable, _dmetVariable2);
  return (0, _createClass2["default"])(dmetSlideVariable);
}(dmetVariable);
var _original = /*#__PURE__*/new WeakMap();
var _id9 = /*#__PURE__*/new WeakMap();
var _list = /*#__PURE__*/new WeakMap();
var _variable = /*#__PURE__*/new WeakMap();
var _table = /*#__PURE__*/new WeakMap();
var _dmet_brand = /*#__PURE__*/new WeakSet();
var _subscriber = /*#__PURE__*/new WeakMap();
var dmet = exports.dmet = /*#__PURE__*/function () {
  function dmet(variables, options) {
    (0, _classCallCheck2["default"])(this, dmet);
    _classPrivateMethodInitSpec(this, _dmet_brand);
    _classPrivateFieldInitSpec(this, _original, {
      list: {},
      variable: {}
    });
    _classPrivateFieldInitSpec(this, _id9, _common["default"].generateId());
    _classPrivateFieldInitSpec(this, _list, {});
    _classPrivateFieldInitSpec(this, _variable, {});
    _classPrivateFieldInitSpec(this, _table, {});
    _classPrivateFieldInitSpec(this, _subscriber, new Map());
    this.from(variables, options);
  }
  return (0, _createClass2["default"])(dmet, [{
    key: "list",
    get: function get() {
      return _classPrivateFieldGet(_list, this);
    }
  }, {
    key: "variable",
    get: function get() {
      return _classPrivateFieldGet(_variable, this);
    }
  }, {
    key: "table",
    get: function get() {
      return _classPrivateFieldGet(_table, this);
    }
  }, {
    key: "id",
    get: function get() {
      return _classPrivateFieldGet(_id9, this);
    }
  }, {
    key: "isDmet",
    get: function get() {
      return true;
    }
  }, {
    key: "original",
    get: function get() {
      return _classPrivateFieldGet(_original, this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: _classPrivateFieldGet(_id9, this),
        list: this.list,
        table: this.table,
        variable: this.variable,
        isDmet: true
      };
    }
  }, {
    key: "from",
    value: function from() {
      var _this4 = this;
      var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (Array.isArray(variables)) {
        variables.forEach(function (variable) {
          var variableType = variable.variableType;
          if (variableType === 'variable') {
            var result = new dmetVariable(variable);
            _classPrivateFieldGet(_variable, _this4)[result.id] = result;
          } else if (variableType === 'slide') {
            var _result2 = new dmetSlideVariable(variable);
            _classPrivateFieldGet(_variable, _this4)[_result2.id] = _result2;
          } else if (variableType === 'list') {
            var _result3 = new dmetList(variable);
            _classPrivateFieldGet(_list, _this4)[_result3.id] = _result3;
          } else if (variableType === 'table') {
            var _result4 = new dmetTable(variable);
            _classPrivateFieldGet(_table, _this4)[_result4.id] = _result4;
          }
        });
      } else if ((0, _isPlainObject["default"])(variables) && variables.isDmet) {
        _classPrivateFieldSet(_list, this, (0, _mapValues2["default"])(variables.list, function (list) {
          return new dmetList(list);
        }));
        _classPrivateFieldSet(_variable, this, (0, _mapValues2["default"])(variables.variable, function (variable) {
          return new dmetVariable(variable);
        }));
        _classPrivateFieldSet(_table, this, (0, _mapValues2["default"])(variables.table, function (list) {
          return new dmetTable(list);
        }));
        _classPrivateFieldSet(_id9, this, variables.id);
      }
    }
  }, {
    key: "get",
    value: function get(_ref5) {
      var variableType = _ref5.variableType,
        id = _ref5.id;
      switch (variableType) {
        case 'variable':
          return _classPrivateFieldGet(_variable, this)[id];
        case 'slide':
          return _classPrivateFieldGet(_variable, this)[id];
        case 'list':
          return _classPrivateFieldGet(_list, this)[id];
        case 'table':
          return _classPrivateFieldGet(_table, this)[id];
        case 'default':
          return undefined;
      }
    }
  }, {
    key: "create",
    value: function create(object) {
      var id = object.id,
        variableType = object.variableType;
      if (!id) {
        throw 'not found ID';
      }
      if (variableType === 'variable') {
        _classPrivateFieldGet(_variable, this)[id] = new dmetVariable(object);
      } else if (variableType === 'slide') {
        _classPrivateFieldGet(_variable, this)[id] = new dmetSlideVariable(object);
      } else if (variableType === 'list') {
        _classPrivateFieldGet(_list, this)[id] = new dmetList(object);
      } else if (variableType === 'table') {
        _classPrivateFieldGet(_table, this)[id] = new dmetTable(object);
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(key, callback) {
      _classPrivateFieldGet(_subscriber, this).set(key, callback);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(key) {
      _classPrivateFieldGet(_subscriber, this)["delete"](key, callback);
    }
  }, {
    key: "notify",
    value: function notify() {
      var _iterator = _createForOfIteratorHelper(_classPrivateFieldGet(_subscriber, this).values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer.apply(void 0, arguments);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "exec",
    value: function exec(operation) {
      try {
        var id = operation.id,
          variableType = operation.variableType;
        if (variableType === 'variable') {
          return _classPrivateFieldGet(_variable, this)[id].exec(operation);
        } else if (variableType === 'slide') {
          return _classPrivateFieldGet(_variable, this)[id].exec(operation);
        } else if (variableType === 'list') {
          return _classPrivateFieldGet(_list, this)[id].exec(operation);
        } else if (variableType === 'table') {
          return _classPrivateFieldGet(_table, this)[id].exec(operation);
        }
      } finally {
        this.notify();
      }
    }
  }]);
}();
function _objectToJSON(object) {
  for (var key in object) {
    object[key] = object[key].toJSON();
  }
  return object;
}